import React, { useMemo } from 'react';
import { PermissionProvider, Auth } from '@billda/permissions-ui';
import { useAuthStore } from '../../features/auth/stores/authStore';

interface Props {
  children: React.ReactNode;
}

export const PermissionsProviderAdapter: React.FC<Props> = ({ children }) => {
  // Subscribe to token value directly from authStore
  const token = useAuthStore(state => state.token);
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);

  const permissions = useMemo(() => {
    // Only try to get token if authenticated
    if (!isAuthenticated) return [];
    return Auth.getPermissionsFromToken(token);
  }, [token, isAuthenticated]);

  return (
    <PermissionProvider permissions={permissions}>
      {children}
    </PermissionProvider>
  );
};
